module.exports = global["riot"] = require("-!/home/ubuntu/searchandiser-ui/node_modules/riot/riot+compiler.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/riot/riot+compiler.js
 ** module id = 205
 ** module chunks = 0
 **/